import BaseApiService from './BaseApiService'

export interface TemplateSample {
  sampleId: string
  templateVersionId: string
  name: string
  payloadJson: string
  createdAt: string
}

class SamplesApiService extends BaseApiService {
  list(templateVersionId: string): Promise<TemplateSample[]> {
    return this.post('/v1/samples/list', { templateVersionId })
  }

  save(templateVersionId: string, name: string, payloadJson: string): Promise<TemplateSample> {
    return this.post('/v1/samples/save', { templateVersionId, name, payloadJson })
  }

  delete(sampleId: string, templateVersionId: string): Promise<{ deleted: boolean }> {
    return this.post('/v1/samples/delete', { sampleId, templateVersionId })
  }
}

export const samplesApiService = new SamplesApiService()
